import { Component, Input, ViewChild } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';

@Component({
    selector: 'datagrid-actions-dropdown',
    templateUrl: './datagrid-actions-dropdown.component.html',
    standalone: false
})
export class DatagridActionsDropdownComponent {
	@Input() stopPropagation = true;
	@ViewChild(MatMenuTrigger) private trigger: MatMenuTrigger;

	closeMenu(): void {
		this.trigger?.closeMenu();
	}
}
